import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import $ from 'jquery';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';

const root = document.getElementById('root');
const search = document.getElementById('drupal-react-search');

if (root) {
  ReactDOM.render(<App />, root);
}

if (search) {
  ReactDOM.render(React.createElement(App, {context: $('body') }), search);
}

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js